import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'mobx-react';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from 'services/AuthService';
import { RootStore } from 'stores';
import { AuthProvider } from 'context';
import 'assets/styles/index.scss';
import App from './App';
import { ThemeProvider } from 'context/Theme/ThemeProvider';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <Provider rootStore={new RootStore()}>
        <AuthProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </AuthProvider>
      </Provider>
    </MsalProvider>
  </React.StrictMode>
);
